export default __webpack_public_path__ + "static/media/logoTpsWithAddress.ee10a5cb.jpg";